<div class="root">
    <h2 mat-dialog-title>Notas Track {{track.channel}}</h2>
    <mat-dialog-content>
        <mat-list class="commentBox" *ngFor="let note of track.notes; index as i"
            infiniteScroll
            [infiniteScrollDistance]="2"
            [infiniteScrollThrottle]="50">
            <mat-card class="matCard">
                <mat-list-item class="commentBox">{{note.note}}</mat-list-item>
                <mat-divider></mat-divider>
                <label class="commentDateInfo">Fecha: {{ note.createdAt }}</label>
            </mat-card>
        </mat-list>
    </mat-dialog-content>
    <mat-dialog-actions>
        <button mat-button color="primary" (click)="onClose()">Cerrar</button>
    </mat-dialog-actions>
</div>